import React from 'react'
import BallySportsMLB from 'src/components/page/bally-sports-mlb'
import { videos } from 'src/constants/videos'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => (
  <BallySportsMLB
    location={props.location}
    video={videos.bally_brewers.videoUrl}
    staticAnnotation={videos.bally_brewers.staticAnnotation}
    title="Watch Milwaukee baseball live"
    subtitle="Stream the Brewers on FanDuel Sports Network Wisconsin"
    teamId={teamIds['Milwaukee Brewers']}
  />
)
